import { createUseStyles } from "react-jss";
import { breakpoints } from "../../../constants/breakpoints";
import { colors } from '../../../constants/colors';

const styles = createUseStyles({
  modalContent: {
    margin: "22px 0 0 0"
  },
  footerBtns: {
    display: "flex",
    justifyContent: "center",
    width: "100%",
    fontSize: "16px",
    fontWeight: "600",
    lineHeight: "24px"
  },
  checkbox: {
    marginRight: "12px",
    cursor: "pointer"
  },
  modal: {
    width: "400px",
    "& .modal-header": {
      padding: "24px 24px 20px",
      "& div": {
        height: "46px",
        padding: "10px",
        "& svg": {
          display: "flex"
        }
      },
      "& button": {
        fontSize: "14px",
        position: "absolute",
        top: "32px",
        right: "32px"
      }
    },
    "& .modal-title": {
      padding: "0 24px"
    },
    "& .modal-body": {
      padding: "8px 24px",
      fontSize: "14px",
      fontWeight: "400",
      lineHeight: "20px"
    },
    "& .modal-footer": {
      padding: "24px 24px"
    },
    "& .modal-footer>*": {
      margin: "0px"
    },
    [`@media (max-width: ${breakpoints.sm}px)`]: {
      width: "auto"
    }
  },
  cancelBtn: {
    extend: "footerBtns",
  },
  cancelBtnCol: {
    paddingRight: "6px"
  },
  saveBtn: {
    extend: "footerBtns",
    "&[class*='disabled']": {
      backgroundColor: `${colors.disabledRed} !important`,
      border: `1px solid ${colors.disabledRed} !important`,
      pointerEvents: "none",
    }
  },
  saveBtnCol: {
    paddingLeft: "6px"
  }
});

export default styles;
